// custom typefaces
import "typeface-montserrat"
import "typeface-merriweather"

import "./src/styles/global.css"

// gatsby-browser.js
require("prismjs/themes/prism.css")
// require("prismjs/themes/prism-okaidia.css")
require("prismjs/plugins/line-numbers/prism-line-numbers.css")
